
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import SsoLogin from '../features/auth/pages/SsoLogin';

const ONELOGIN_URL = 'https://sagilityhealth.onelogin.com/';

const RootRoute = () => {
  const [searchParams] = useSearchParams();
  const encryptedId = searchParams.get('eid');

  useEffect(() => {
    if (!encryptedId?.trim()) {
      window.location.replace(ONELOGIN_URL);
    }
  }, [encryptedId]);

  if (encryptedId?.trim()) {
    return <SsoLogin />;
  }

  return null;
};

export default RootRoute;
